// The ONE canonical SoftwareApplication node for the AI-Advisors product.
// Single source of truth, emitted on the homepage (app/page.jsx), /pricing,
// and every /platform/* page (via PlatformPageTemplate). All emissions share
// the same @id so engines merge them into one entity - never fork a copy of
// this node or hand-write a second SoftwareApplication anywhere.
//
// Conventions (memory: project_structured_data_state_2026):
// - No `image` here: not a recommended prop for SoftwareApplication.
// - No `aggregateRating` until GENUINE third-party reviews exist. Never
//   self-assert ratings (that is the get-ryze.ai fake-stars pattern).
// - Prices are the real /pricing tiers; update here when pricing changes.
export const softwareAppSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": "https://www.ai-advisors.ai/#software",
  "name": "AI-Advisors",
  "description": "AI marketing platform for mid-market B2B teams. Track, audit, and optimize your brand's visibility across ChatGPT, Claude, Gemini, Perplexity, and Grok.",
  "url": "https://www.ai-advisors.ai",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "inLanguage": "en-US",
  "offers": [
    {
      "@type": "Offer",
      "name": "Starter",
      "description": "14-day free trial included",
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "price": "49",
        "priceCurrency": "USD",
        "billingDuration": "P1M"
      }
    },
    {
      "@type": "Offer",
      "name": "Growth",
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "price": "99",
        "priceCurrency": "USD",
        "billingDuration": "P1M"
      }
    }
  ],
  "provider": { "@id": "https://www.ai-advisors.ai/#organization" },
  "author": { "@id": "https://www.ai-advisors.ai/#person-kevin" },
  // Product-profile directory listings. Organization-level profiles (Crunchbase,
  // LinkedIn, X, Wikidata) live in the Organization sameAs, not here.
  //
  // These pages 403-challenge scripted fetches (Cloudflare), but they do load in
  // a real browser: the Capterra, GetApp, Software Advice, and AlternativeTo
  // entries were each browser-verified 2026-07-31 as live, on-entity, indexable
  // (no noindex), and self-canonical to these exact URLs. Add new entries only
  // on Kevin's confirmation that a listing is LIVE - never while it is still
  // awaiting editorial approval, since an unresolvable or off-entity sameAs is a
  // negative signal.
  "sameAs": [
    "https://www.g2.com/products/ai-advisor/reviews",
    // Capterra + GetApp + Software Advice all come from the one G2 Digital
    // Markets submission (2026-07-09). Capterra wired 2026-07-29; the GetApp and
    // Software Advice URLs landed 2026-07-31.
    "https://www.capterra.com/p/10050784/AI-Advisors/",
    "https://www.getapp.com/all-software/a/ai-advisors/",
    "https://www.softwareadvice.com/product/558365-AI-Advisors/",
    // Approved by AlternativeTo 2026-07-29. Uses the ROOT product URL, not the
    // /about/ tab: the root is the canonical entity page and the tab is a
    // sub-view of it.
    "https://alternativeto.net/software/ai-advisors/",
    // Official app-marketplace listings, added 2026-08-09 (both verified live
    // + on-entity the same day). Their links TO us carry no equity (WordPress
    // nofollows everything; HubSpot's links are JS-rendered), so binding them
    // here is how they join the entity graph.
    "https://wordpress.org/plugins/ai-advisors/",
    "https://ecosystem.hubspot.com/marketplace/listing/ai-advisors-chatgpt-ads"
  ]
};
